import PropTypes from "prop-types";
import React from "react";
import { priceType, subscribeLinkType } from "../../../common/types";
import { SEGMENT_BZA, SEGMENT_CMC } from "../../constants";
import { HeroPackage } from "./HeroPackage";
import clsx from "clsx";
import { HeroRequest } from "./HeroRequest";

export function Hero({ title, subtitle, packages }) {
	const singlePackage = packages.length === 1;

	const subscriptionOptions = packages.map((item, index) => {
		const { label, title, subtitle, features, price, subscribeLinkUrl } =
			item;

		return (
			<HeroPackage
				key={index}
				label={label}
				title={title}
				subtitle={subtitle}
				features={features}
				price={price}
				singlePackage={singlePackage}
				subscribeLinkUrl={subscribeLinkUrl}
			/>
		);
	});

	return (
		<section
			className={clsx("section--hero", {
				"section--hero-single-package": singlePackage,
			})}
		>
			<div className="hero__content">
				<div className="hero__banner grid">
					<div className="hero__title grid__col-12 grid__col-sm-5 grid__col-lg-9 align-start">
						<h1>{title}</h1>
						<p className="hero__lead">{subtitle}</p>
					</div>
					<div
						className={clsx("hero__packages", {
							"grid__col-12 grid__col-sm-7 grid__col-lg-3":
								singlePackage,
						})}
					>
						{subscriptionOptions}
					</div>
					{!singlePackage && (
						<div className="hero__packages-disclaimer">
							<span>
								All subscriptions can be cancelled monthly, no
								long-term commitment.
							</span>
						</div>
					)}
					<HeroRequest singlePackage={singlePackage} />
				</div>
			</div>
		</section>
	);
}

Hero.propTypes = {
	title: PropTypes.string.isRequired,
	subtitle: PropTypes.string.isRequired,
	packages: PropTypes.arrayOf(
		PropTypes.shape({
			label: PropTypes.oneOf([SEGMENT_CMC, SEGMENT_BZA, "Most Popular"]),
			title: PropTypes.string,
			subtitle: PropTypes.string,
			features: PropTypes.arrayOf(PropTypes.string),
			price: priceType.isRequired,
			subscribeLinkUrl: subscribeLinkType.isRequired,
		}).isRequired,
	).isRequired,
};
